import { IconInfoCircle } from '@tabler/icons-react'
import { ConfirmDialog } from '@/components/confirm-dialog'

const ConfirmDeleteModal = ({
  isOpenConfirmDelete,
  setIsOpenConfirmDelete,
  isDeleting,
  handleDeleteUser,
}: {
  isOpenConfirmDelete: boolean
  setIsOpenConfirmDelete: (isOpen: boolean) => void
  isDeleting: boolean
  handleDeleteUser: () => void
}) => {
  return (
    <ConfirmDialog
      open={isOpenConfirmDelete}
      onOpenChange={setIsOpenConfirmDelete}
      handleClose={() => setIsOpenConfirmDelete(false)}
      title={
        <div className='flex w-full justify-center'>
          <div className='flex h-20 w-20 items-center justify-center rounded-full bg-gray-100 text-gray-600'>
            <IconInfoCircle size={40} />
          </div>
        </div>
      }
      desc={
        <div className='text-center'>
          <p className='text-[#171717]'>Deleting this user is permanent.</p>
          Are you sure you want to delete this user?
        </div>
      }
      cancelBtnText='Cancel'
      confirmText='Delete'
      isLoading={isDeleting}
      handleConfirm={() => {
        handleDeleteUser()
      }}
      className='max-w-md'
    />
  )
}

export default ConfirmDeleteModal
